<template>
  <div>
    <div class="gradient">
      <div class="container">
        <div class="row" style="color: white">
          <div class="d-block d-sm-none col-12">
            <img src="../assets/page_activasolo_header.png" alt="" class="img-fluid p-5 mx-auto d-block" width="90%">
          </div>
          <div class="col-12 col-lg-5" style="margin-top: auto; margin-bottom: auto">
            <h1 class="text-center">Activa-solo</h1>
            <h2 class="text-center mb-4">Emula el trabajo de tus activadores.</h2>
            <p class="text-justify">
              Es una herramienta que automatiza el proceso de activación de sims prepago Unefon® y At&t®.
            </p>
            <p class="text-justify mb-5">
              Realiza de manera autónoma y cíclica, los pasos a seguir para la correcta activación de lineas dentro de
              AVS, las veces que sea necesario.
            </p>
          </div>
          <div class="col-7 d-none d-sm-block">
            <img src="../assets/page_activasolo_header.png" alt="" class="img-fluid p-5 mx-auto d-block" width="90%">
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row mb-5" style="position: relative; top:-15px">
        <div class="col-lg-3 col-hover px-0" v-for="card in cards">
          <div :style="`height: 30px; background-color: ${card.color}`"></div>
          <h3 class="text-center px-5 my-3" style="height: 65px;">{{card.titulo}}</h3>
          <p class="text-justify px-4">{{card.texto}}</p>
        </div>
      </div>
      <div class="row mb-5">
        <div class="col-12 col-lg-6" style="margin-top: auto; margin-bottom: auto;">
          <div id="carousel-example-2" class="carousel slide" data-ride="carousel">
            <ol class="carousel-indicators">
              <li data-target="#carousel-example-2" data-slide-to="0" class="active"></li>
              <li data-target="#carousel-example-2" data-slide-to="1"></li>
              <li data-target="#carousel-example-2" data-slide-to="2"></li>
            </ol>
            <div class="carousel-inner" role="listbox">
              <div class="carousel-item active">
                <div class="view" style="margin-bottom: 100px">
                  <img class="d-none d-sm-block mx-auto" src="../assets/page_activasolo_slider01.png" height="200px"
                       alt="First slide">
                  <img class="d-block d-sm-none mx-auto" src="../assets/page_activasolo_slider01.png" height="150px"
                       alt="First slide">
                </div>
                <div class="carousel-caption" style="color: black">
                  <p>Activa-Solo versión V2.0 Panel de configuración</p>
                </div>
              </div>
              <div class="carousel-item">
                <div class="view" style="margin-bottom: 100px">
                  <img class="d-none d-sm-block mx-auto" src="../assets/page_activasolo_slider02.png" height="200px"
                       alt="Second slide">
                  <img class="d-block d-sm-none mx-auto" src="../assets/page_activasolo_slider02.png" height="150px"
                       alt="Second slide">
                </div>
                <div class="carousel-caption" style="color: black">
                  <p>Activa-Solo versión V3.0 Panel de configuración</p>
                </div>
              </div>
              <div class="carousel-item">
                <div class="view" style="margin-bottom: 100px">
                  <img class="d-none d-sm-block mx-auto" src="../assets/page_activasolo_slider03.png" height="200px"
                       alt="Third slide">
                  <img class="d-block d-sm-none mx-auto" src="../assets/page_activasolo_slider03.png" height="150px"
                       alt="Third slide">
                </div>
                <div class="carousel-caption" style="color: black">
                  <p>Activa-Solo versión V3.5 Panel de configuración</p>
                </div>
              </div>
            </div>
            <a class="carousel-control-prev" href="#carousel-example-2" role="button" data-slide="prev">
                <span class="" aria-hidden="true"><i
                  class="fas fa-chevron-left fa-3x "></i></span>
              <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carousel-example-2" role="button" data-slide="next">
                <span class="" aria-hidden="true"><i
                  class="fas fa-chevron-right fa-3x"></i></span>
              <span class="sr-only">Next</span>
            </a>
          </div>
        </div>
        <div class="col-12 col-lg-6 px-5">
          <p>
            Activa solo cuenta con 3 versiones:
          </p>
          V2.0
          <ul>
            <li>
              <p style="color: black" class="mb-0">Configura usuario y contraseña para iniciar sesión en AVS cuando sea
                requerido.</p>
            </li>
            <li>
              <p style="color: black" class="mb-0">Configura los sims que deseas activar</p>
            </li>
            <li>
              <p style="color: black" class="mb-0">Coloca la lada que se activarán tus sims.</p>
            </li>
            <li>
              <p style="color: black" class="mb-0">Decide si son At&t® o Unefon®</p>
            </li>
          </ul>
          V3.0(Multi-lada)
          <ul>
            <li>
              <p style="color: black" class="mb-0">Incluye las bondades de la versión V2.0</p>
            </li>
            <li>
              <p style="color: black" class="mb-0">Además, te ofrece configurar hasta 10 ladas distintas para agregar
                mayor autonomía a tu proceso de
                activación</p>
            </li>
          </ul>
          V3.5(Multilada y multimarca)
          <ul>
            <li>
              <p style="color: black" class="mb-0">Incluye las bondades de la versión V3.5</p>
            </li>
            <li>
              <p style="color: black" class="mb-0">Se agrega la funcionalidad de poder seleccionar el carrier en cada
                una de las 10 ladas configurables,
                duplicando la capacidad de autonomía.</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="row justify-content-center mb-4">
        <div class="col-8 col-lg-3">
          <a class=" btn  text-capitalize z-depth-0  py-1" style="color: white !important; background-color: #00A492 !important;" @click="to('Landing')" href="#contact">
            <p class="text-truncate ml-auto mr-auto my-1">Solicitar Demo</p>
          </a>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ActivaSolo",
    data() {
      return {
        cards: [{
          color: `#00A492`,
          titulo: `Disponible`,
          texto: `Si eres distribuidor At&t®/Unefon®, esta solución es para ti.`
        }, {
          color: `#008DA3`,
          titulo: `Ahorra costos operativos`,
          texto: `Disminuye los costos en tu operación con menos gastos de nómina.
                  Coloca a tu personal en otras actividades y obtén más beneficios.`
        }, {
          color: `#0064A3`,
          titulo: `Activa en todo momento`,
          texto: `Activa-solo es capaz de activar sin interrupciones mientras AVS este en línea.
                  Activa en cualquier horario del día, nuestra solución es capaz de iniciar sesión en AVS por sí sola si es necesario.`
        }, {
          color: `#2F395D`,
          titulo: `¡Comienza ya!`,
          texto: `Permite que tus computadoras realicen las tareas repetitivas.
                  Puedes configurar a Activa-solo hasta 10 ladas diferentes de activación.`
        }]
      }
    },
    methods:{
      to(route){
        this.$router.push({name:route})
      }
    }
  }
</script>

<style scoped>

  .gradient {
    background: rgba(0,141,163,1);
    background: -moz-linear-gradient(left, rgba(0,141,163,1) 0%, rgba(0,164,145,1) 100%);
    background: -webkit-gradient(left top, right top, color-stop(0%, rgba(0,141,163,1)), color-stop(100%, rgba(0,164,145,1)));
    background: -webkit-linear-gradient(left, rgba(0,141,163,1) 0%, rgba(0,164,145,1) 100%);
    background: -o-linear-gradient(left, rgba(0,141,163,1) 0%, rgba(0,164,145,1) 100%);
    background: -ms-linear-gradient(left, rgba(0,141,163,1) 0%, rgba(0,164,145,1) 100%);
    background: linear-gradient(to right, rgba(0,141,163,1) 0%, rgba(0,164,145,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#008da3', endColorstr='#00a491', GradientType=1 );
  }

  .col-hover:hover {
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .2), 0 6px 7px 0 rgba(0, 0, 0, .7) !important;
  }

  li {
    color: #00A492;
  }

  span {
    color: #00A492;
  }

  .carousel .carousel-indicators li {
    background-color: #00A492;
    width: 2.3rem;
    height: .7rem;
    border-radius: .9rem;
  }

  .btn{
    background-color: white;
    border-radius:25px!important;
    width:100%!important;
  }
</style>

